import {pageService} from "../services/pages.services";

import AuthService from '../lib/AuthService';
let Auth = new AuthService();

export const setPage = ( page ) => dispatch => {
    dispatch({
        type: "SET_PAGE",
        page
    });
}

export const getPage = (state) => dispatch => {
    dispatch({
        type: "GET_PAGE",
        state
    });
}

export const checkLogin = (data ) => dispatch => {

    let loggedInUser = pageService.loginUser(data);

console.log(loggedInUser);
    loggedInUser.then(loggedInUser => {

        if(loggedInUser && loggedInUser.data) {
            Auth.login(loggedInUser.data.response);

            dispatch({
                type: "USER_LOGGEDIN",
                loggedInUser
            });
        }
        else {
            dispatch({
                type: "USER_LOGGEDIN_FAILURE"
            });
        }

    });
}
export const checkLogout = (data ) => dispatch => {

    dispatch({
        type: "USER_LOGGEDOUT"
    });

}
export const resetPassword = (data ) => dispatch => {
    let resetPassword = pageService.resetPassword(data);
    dispatch({
        type: "USER_PSWDRESET"
    });
}


export const logActivity = (data ) => dispatch => {

    let logActivity = pageService.activityLog(data);
    console.log(logActivity);
}
export const saveConfig = (data ) => dispatch => {
console.log(data)
    dispatch({
        type: "SAVE_CONFIG",
        data : data
    });

}


// WEBPACK FOOTER //
// ./src/actions/pages.js